import { waitFor } from '../utils'

export async function retry<T>(fn: () => Promise<T>, maxAttempts = 10, delay = 1000, maxDelay = 15_000): Promise<T> {
  let lastError: unknown
  let delayWithBackoff = delay
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    try {
      return await fn()
    } catch (error) {
      lastError = error
      if (attempt < maxAttempts - 1) {
        const jitter = Math.floor(Math.random() * 10)
        await waitFor(delayWithBackoff + jitter)
        delayWithBackoff = Math.min(Math.floor(delayWithBackoff * 1.5), maxDelay)
      }
    }
  }
  throw lastError
}
